enum EstadosModalOrdenTraslado {
    CERRADO = 'CERRADO',
    CREACION = 'CREACION',
    EDICION = 'EDICION',
    VISUALIZACION = 'VISUALIZACION',
}

export { EstadosModalOrdenTraslado };
